import { HEX } from "../../../src/actions/hex-patterns";
import { Targeting } from "../../../src/actions/targeting";
import { SEC } from "../../../src/time-utils";
const flame_shell = {
  slug: "flame_shell",
  name: "Flame Shell",
  description: "Surrounds yourself in flames that burn melee attackers",
  abilityIcon: "flame_shell",
  costs: [
    { stat: "mana", value: 12 }
  ],
  targeting: Targeting.Self,
  cooldown: SEC(8),
  impactSchedule: {
    [0]: [
      {
        hexes: HEX.DOT,
        effect: {
          statChanges: [
            {
              stat: "health",
              direction: "loss",
              scalingFactors: {}
            }
          ],
          addConditions: [
            {
              slug: "flame_shell",
              name: "Flame Shell",
              tags: ["buff", "fire"]
            }
          ],
          removeConditionsByTag: []
        }
      }
    ]
  },
  tags: ["spell", "buff", "red", "defensive"]
};
export {
  flame_shell
};
//# sourceMappingURL=data:application/json;base64,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
